module.exports = __webpack_public_path__ + "static/img/2_fun.ea66573.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/2_fun.png
// module id = MV4u
// module chunks = 0